import React from 'react';
import styled from 'styled-components';
import theme from '../utils/theme';
import MainBanner from './common/MainBanner';
import CarRed from '../assets/CarValuePromotion/car-red.png';

export default function CarValuePromotion() {
  return (
    <MainBanner>
      <BannerDiv>
        <CarImage src={CarRed} alt="빨간색 자동차" />
        <BannerText>
          <SmallText>이미 차량담보대출을 이용 중이더라도</SmallText>
          <HighlightText>
            내차 시세의<br />
            130%까지<br /><br />
          </HighlightText>
        </BannerText>
      </BannerDiv>
    </MainBanner>
  );
}

const BannerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
`;

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  text-align: center;
  gap: 8px;
`;

const SmallText = styled.span`
	margin-top: 30px;
  color: #333;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.4;
`;

const HighlightText = styled.div`
	margin-top: 30px;
  color: #ffd700;
  font-size: 60px;
  font-weight: 900;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;

const CarImage = styled.img`
  margin-top: 50px;
  width: 90%;
  height: auto;
  display: flex;
  align-self: center;
  object-fit: contain;
`; 